class BenefitDictionary {
    constructor() {
        this.benefits = {
            maxcovpipoly: {
                value: 'max_coverage',
                options: {
                    maxcovpipoly_500000: { value: 'MAX500K' },
                    maxcovpipoly_1000000: { value: 'MAX1M' },
                    maxcovpipoly_2000000: { value: 'MAX2M' },
                    maxcovpipoly_3000000: { value: 'MAX3M' },
                    maxcovpipoly_4000000: { value: 'MAX4M' },
                    maxcovpipoly_5000000: { value: 'MAX5M' },
                    maxcovpipoly_unlimited: { value: 'MAXUNLIM' },
                },
            },
            geogrcov: {
                value: 'geo_coverage',
                options: {
                    latam: { value: 'GEOLAT' },
                    wwide: { value: 'GEOWW' },
                    wwltd: { value: 'GEOWWEEXP' },
                },
            },
            provdnet: {
                value: 'coverage_us',
                options: {
                    lalted: { value: 'NETUSD' },
                    laopen: { value: 'NETUSC' },
                    gllted: { value: 'NETUSB' },
                    glopen: { value: 'NETUSOPEN' },
                },
            },
            dedusa: {
                value: 'ded_inside_country',
                options: {
                    dedusa_2000: { value: 'DEDUIN2K' },
                    dedusa_3500: { value: 'DEDUIN3500' },
                    dedusa_5000: { value: 'DEDUIN5K' },
                    dedusa_10000: { value: 'DEDUIN10K' },
                    dedusa_20000: { value: 'DEDUIN20K' },
                    dedusa_50000: { value: 'DEDUIN50K' },
                    dedusa_na: { value: 'DEDUINNO' },
                },
            },
            dednonusa: {
                value: 'ded_outside_country',
                options: {
                    dednonusa_500: { value: 'DEDOUT500' },
                    dednonusa_1000: { value: 'DEDOUT1K' },
                    dednonusa_2000: { value: 'DEDOUT2K' },
                    dednonusa_3500: { value: 'DEDOUT3500' },
                    dednonusa_5000: { value: 'DEDOUT5K' },
                    dednonusa_10000: { value: 'DEDOUT10K' },
                    dednonusa_20000: { value: 'DEDOUT20K' },
                    dednonusa_50000: { value: 'DEDOUT50K' },
                },
            },
            coinsurance: {
                value: 'co_insurance',
                options: {
                    coinsurance_50: { value: 'COIN50' },
                    coinsurance_20: { value: 'COIN20' },
                    coinsurance_no: { value: 'COINNO' },
                },
            },
            maxcoinoop: {
                value: 'maximum_oop',
                options: {
                    maxcoinoop_50000: { value: 'MOOP50K' },
                    maxcoinoop_2000: { value: 'MOOP2K' },
                    maxcoinoop_3500: { value: 'MOOP3500' },
                    maxcoinoop_5000: { value: 'MOOP5000' },
                    maxcoinoop_no: { value: 'MOOPNO' },
                    maxcoinoop_unlimited: { value: 'MOOPUNLIM' },
                },
            },
            congenit: {
                value: 'cong_conditions',
                options: {
                    congenit_150000: { value: 'CONG15OK' },
                    congenit_250000: { value: 'CONG25OK' },
                    congenit_500000: { value: 'CONG50OK' },
                    congenit_1000000: { value: 'CONG1M' },
                    congenit_2000000: { value: 'CONG2M' },
                }
            },
            hazardsp: {
                value: 'haz_hobbie_sports',
                options: {
                    hazardsp_100000: { value: 'NHZR100K' },
                    hazardsp_250000: { value: 'NHZR250K' },
                    hazardsp_500000: { value: 'NHZR500K' },
                    hazardsp_no: { value: 'NHZRNO' },
                },
            },
            inmental: {
                value: 'mental_medication',
                options: {
                    inmental_50000: { value: 'MENT050K' },
                    inmental_100000: { value: 'MENT100K' },
                    inmental_150000: { value: 'MENT150K' },
                    inmental_no: { value: 'MENTALNO' },
                },
            },
            orgtrans: {
                value: 'org_transplant',
                options: {
                    orgtrans_250000: { value: 'ORGT250K' },
                    orgtrans_500000: { value: 'ORGT500K' },
                    orgtrans_1000000: { value: 'ORGTRS1M' },
                    orgtrans_2000000: { value: 'ORGTRS2M' },
                },
            },
            deathcov: {
                value: 'free_ext_cov',
                options: {
                    deathcov_1year: { value: 'DTH1YEAR' },
                    deathcov_2years: { value: 'DTH2YEAR' },
                    deathcov_no: { value: 'DTHNO' },
                },
            },
            mxoutcov: {
                value: 'outpatient_coverage',
                options: {
                    mxoutcov_50000: { value: 'OUTP050K' },
                    mxoutcov_100000: { value: 'OUTP050K' },
                    mxoutcov_250000: { value: 'OUTP250K' },
                    mxoutcov_unlimited: { value: 'OUTPUNLM' },
                    mxoutcov_no: { value: 'OUTPNO' },
                },
            },
            compther: {
                value: 'comp_therapy',
                options: {
                    compther_2500: { value: 'CMPT2500' },
                    compther_5000: { value: 'CMPT005K' },
                    compther_10000: { value: 'CMPT010K' },
                    compther_no: { value: 'CMPTTHNO' },
                },
            },
            deductbl: {
                value: 'deductible_reduction',
                options: {
                    deductbl_yes: { value: 'DEDURYES' },
                    0: { value: 'DEDURDNO' },
                },
            },
            matrnity: {
                value: 'matborn_compl',
                options: {
                    matrnity_150000: { value: 'MATE150K' },
                    matrnity_250000: { value: 'MATE250K' },
                    matrnity_500000: { value: 'MATE500K' },
                    matrnity_1000000: { value: 'MATERN1M' },
                    matrnity_2000000: { value: 'MATERN2M' },
                    matrnity_no: { value: 'MATERNNO' },
                },
            },
            eyesurgr: {
                value: 'eye_surgery',
                options: {
                    eyesurgr_2500: { value: 'EYESUYES' },
                    eyesurgr_no: { value: 'EYESURNO' },
                },
            },
            barsurgr: {
                value: 'bariatric_surgery',
                options: {
                    barsurgr_10000: { value: 'BARS010K' },
                    barsurgr_25000: { value: 'BARS025K' },
                    barsurgr_50000: { value: 'BARS050K' },
                    barsurgr_no: { value: 'BARSURNO' },
                },
            },
            healthch: {
                value: 'preventive_health',
                options: {
                    healthch_250: { value: 'PREVH250' },
                    healthch_500: { value: 'PREVH500' },
                    healthch_1000: { value: 'PREVHT1K' },
                    healthch_no: { value: 'PREVHTNO' },
                },
            },
        };
    }

    getBenefitValue(benefitCode) {
        return this.benefits[benefitCode]?.value;
    }

    getOptionValue(benefitCode, optionCode) {
        return this.benefits[benefitCode]?.options[optionCode]?.value;
    }
}

export default BenefitDictionary;
